import { useState } from "react";

import {
  FaArrowDown,
  FaArrowLeft,
  FaArrowUp,
  FaFilter,
  FaChartLine,
  FaWallet,
  FaMinus,
} from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import ProfileService from "../../../../services/Profile";
import { useEffect } from "react";
import TransactionService from "../../../../services/Transaction";

export default function FinancialReport() {
  const [activeTab, setActiveTab] = useState("all");
  const navigate = useNavigate();

  const [currentBalance, setCurrentBalance] = useState(0);

  const [transactionList, setTransactionList] = useState([]);
  const [incomeList, setIncomeList] = useState([]);
  const [expenseList, setExpenseList] = useState([]);

  const [incomeTotal, setIncomeTotal] = useState(0);
  const [expenseTotal, setExpenseTotal] = useState(0);

  async function getAllTransAction() {
    try {
      const res = await TransactionService.getAllTransActions();
      console.log("transaction:", res);
      if (res?.status === 200) {
        const income = res.data?.data.filter((tx) => !tx.isPaid);
        const expense = res.data?.data.filter((tx) => tx.isPaid);

        setIncomeList(income);
        setExpenseList(expense);

        setIncomeTotal(
          income.reduce((total, tx) => total + (tx.price || 0), 0),
        );
        setExpenseTotal(
          expense.reduce((total, tx) => total + (tx.price || 0), 0),
        );

        setTransactionList(res.data?.data);
      }
    } catch (err) {
      console.error("Error fetching transactions:", err);
    }
  }

  const toggleTab = (tab) => {
    setActiveTab(tab);
    if (tab === "all") {
      setTransactionList([...incomeList, ...expenseList]);
    } else if (tab === "income") {
      setTransactionList(incomeList);
    } else if (tab === "expense") {
      setTransactionList(expenseList);
    }
  };

  async function getProfile() {
    try {
      const res = await ProfileService.getProfile();
      setCurrentBalance(res.data?.data?.finduser?.wallet?.balance ?? 0);
    } catch (err) {
      console.error("Error fetching profile:", err);
    }
  }
  useEffect(() => {
    getProfile();
    getAllTransAction();
  }, []);

  return (
    <div dir="ltr" className=" w-full md:min-h-screen bg-[#f9fafb] px-4">
      <div className="fixed top-0 left-0 right-0 shadow-sm z-50 bg-white px-5 py-4 flex items-center justify-between border-b border-gray-100">
        <button
          onClick={() => navigate("/profile")}
          className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center hover:bg-gray-200 transition-all"
        >
          <FaArrowLeft className="text-gray-600" />
        </button>
        <h1 className="font-bold text-lg">Financial Reports</h1>
        <button className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center hover:bg-gray-200 transition-all">
          <FaFilter className="text-gray-600" />
        </button>
      </div>
      <div className="grid grid-cols-2 gap-4 py-6 mt-16">
        <div className="bg-white rounded-3xl p-5 shadow-sm border border-gray-100">
          <div className="w-12 h-12 bg-green-50 rounded-2xl flex items-center justify-center mb-4">
            <FaArrowUp className="text-green-600  m-4" />
          </div>
          <span className="mb-2">{incomeTotal.toLocaleString("en-US")}</span>
          <p className="text-sm text-gray-500">Total Income</p>
          {/*<div className="flex">*/}
          {/*    <FaArrowUp className="text-green-600 ml-1" />*/}
          {/*    <span className="">*/}
          {/*        0% increase this month*/}
          {/*    </span>*/}
          {/*</div>*/}
        </div>
        <div className="bg-white rounded-3xl p-5 shadow-sm border border-gray-100">
          <div className="w-12 h-12 bg-red-50 rounded-2xl flex items-center justify-center mb-4">
            <FaArrowDown className="text-red-600 bg-red-50 m-4" />
          </div>
          <span className="mb-2">{expenseTotal.toLocaleString("en-US")}</span>
          <p className="text-sm text-gray-500">Total Expenses</p>
          {/*<div className="flex">*/}
          {/*    <FaArrowDown className="text-red-600 ml-1" />*/}
          {/*    <span className="">*/}
          {/*        0% increase this month*/}
          {/*    </span>*/}
          {/*</div>*/}
        </div>

        <div
          className="w-full bg-gradient-to-r
                    col-span-2 from-[#7B8FEB] to-indigo-500 text-white rounded-3xl p-6 mt-6"
        >
          <div className="flex items-center justify-between mb-4">
            <div className="flex flex-col">
              <span className="text-sm opacity-80">Net Balance</span>
              <span className="text-3xl font-bold">
                {currentBalance?.toLocaleString("en-US")}
              </span>
            </div>
            <div
              // onClick={()=> navigate("/wallet")}
              className="w-12 h-12 bg-white/20 rounded-2xl flex items-center justify-center"
            >
              <FaWallet />
            </div>
          </div>
          {/* <div className="flex gap-2 items-center">
                        <FaChartLine className="text-white/80 ml-2" />
                        <span className="opacity-90">
                            Positive cash flow this
                            month
                        </span>
                    </div> */}
        </div>
      </div>
      {/* button */}
      <div className=" mb-4 bg-white rounded-2xl p-2 border border-gray-100 flex">
        <button
          onClick={() => toggleTab("all")}
          className={`flex-1 py-2 rounded-xl text-sm font-medium transition-all cursor-pointer ${
            activeTab === "all"
              ? "bg-[#7b8feb] text-white font-semibold"
              : "text-gray-500 hover:bg-gray-50"
          }`}
        >
          All
        </button>
        <button
          onClick={() => toggleTab("income")}
          className={`flex-1 py-2 rounded-xl text-sm font-medium transition-all cursor-pointer ${
            activeTab === "income"
              ? "bg-[#7b8feb] text-white font-semibold"
              : "text-gray-500 hover:bg-gray-50"
          }`}
        >
          Income
        </button>
        <button
          onClick={() => toggleTab("expense")}
          className={`flex-1 py-2 rounded-xl text-sm font-medium transition-all cursor-pointer ${
            activeTab === "expense"
              ? "bg-[#7b8feb] text-white font-semibold"
              : "text-gray-500 hover:bg-gray-50"
          }`}
        >
          Expense
        </button>
      </div>

      <div className=" mt-4 pb-32">
        {transactionList.length === 0 && (
          <div className="text-center py-6 text-gray-500 text-sm">
            No transactions found
          </div>
        )}

        {[...transactionList]
          .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
          .reduce((groups, tx) => {
            const today = new Date();
            today.setHours(0, 0, 0, 0);

            const transactionDate = new Date(tx.createdAt);
            transactionDate.setHours(0, 0, 0, 0);

            const isToday = transactionDate.getTime() === today.getTime();

            const groupTitle = isToday ? "Today" : "Past Transaction";
            const lastGroup = groups[groups.length - 1];
            if (lastGroup && lastGroup.groupTitle === groupTitle) {
              lastGroup.transactions.push(tx);
            } else {
              groups.push({ groupTitle, transactions: [tx] });
            }
            return groups;
          }, [])
          .map((group) => (
            <div key={group.groupTitle}>
              <h3 className="text-sm font-semibold text-gray-500 mt-3 mb-1">
                {group.groupTitle}
              </h3>
              <div className="bg-white rounded-2xl border border-gray-100 divide-y divide-gray-50">
                {group.transactions.map((tx) => {
                  const date = new Date(tx.createdAt);
                  const isIncome = !tx.isPaid;
                  const isExpense = tx.isPaid;
                  const amount = tx.price?.toLocaleString("en-US") || "-";
                  const description = tx.description || "-";
                  const timeStr = date.toLocaleTimeString("en-US", {
                    hour: "2-digit",
                    minute: "2-digit",
                  });

                  let icon = <FaWallet className="text-green-600" />;
                  let bg = "bg-green-50";
                  if (isExpense) {
                    icon = <FaMinus className="text-red-600" />;
                    bg = "bg-red-50";
                  }

                  return (
                    <div
                      key={tx._id}
                      className="p-4 flex items-center justify-between"
                    >
                      <div className="flex items-center gap-4">
                        <div
                          className={`w-12 h-12 ${bg} rounded-2xl flex items-center justify-center`}
                        >
                          {icon}
                        </div>
                        <div className="text-right mr-3">
                          <h4 className="font-semibold text-gray-900">
                            {description}
                          </h4>
                         
                        </div>
                      </div>
                      <div className="flex flex-col text-left">
                        <span
                          className={`text-lg font-bold ${isIncome ? "text-green-600" : "text-red-600"}`}
                        >
                          {isIncome ? "+" : "-"}
                          {amount}
                        </span>
                        <span className="text-xs text-gray-500">{timeStr}</span>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
      </div>

      {/* section */}
      {/* Today */}
      {/* <div>
                <h3 className="text-sm font-semibold text-gray-500 mb-3 px-2">
                    Today
                </h3>
                <div className="bg-white rounded-2xl border border-gray-100 divide-y divide-gray-50">
                    <div className="p-4 flex items-center justify-between">
                        <div className="flex items-center">
                            <div className="w-12 h-12 bg-green-50 rounded-2xl flex items-center justify-center">
                                <FaPlus className="text-green-600" />
                            </div>
                            <div className="text-right mr-3">
                                <h4 className="font-semibold text-gray-900">
                                    Signal Package
                                    Purchase
                                </h4>
                                <p className="text-sm text-gray-500">
                                    Package
                                    john_smith
                                </p>
                            </div>
                            <div className="text-right mr-3"></div>
                        </div>
                        <div className="flex flex-col">
                            <span className="text-lg font-bold text-green-600 text-left">
                                +150,000
                            </span>
                            <span className="text-xs text-gray-500 text-left">
                                14:30
                            </span>
                        </div>
                    </div>
                </div>
                <div className="bg-white rounded-2xl border border-gray-100 divide-y divide-gray-50">
                    <div className="p-4 flex items-center justify-between">
                        <div className="flex items-center">
                            <div className="w-12 h-12 bg-blue-50 rounded-2xl flex items-center justify-center">
                                <FaGift className="text-blue-600" />
                            </div>
                            <div className="text-right mr-3">
                                <h4 className="font-semibold text-gray-900">
                                    Invite Reward
                                </h4>
                                <p className="text-sm text-gray-500">
                                    Mary Johnson
                                    joined
                                </p>
                            </div>
                            <div className="text-right mr-3"></div>
                        </div>
                        <div className="flex flex-col">
                            <span className="text-lg font-bold text-green-600 text-left">
                                +50,000
                            </span>
                            <span className="text-xs text-gray-500 text-left">
                                11:15
                            </span>
                        </div>
                    </div>
                </div>
                <div className="bg-white rounded-2xl border border-gray-100 divide-y divide-gray-50">
                    <div className="p-4 flex items-center justify-between">
                        <div className="flex items-center">
                            <div className="w-12 h-12 bg-red-50 rounded-2xl flex items-center justify-center">
                                <FaMinus className="text-red-600" />
                            </div>
                            <div className="text-right mr-3">
                                <h4 className="font-semibold text-gray-900">
                                    Subscription Renewal
                                </h4>
                                <p className="text-sm text-gray-500">
                                    Premium Plan
                                </p>
                            </div>
                            <div className="text-right mr-3"></div>
                        </div>
                        <div className="flex flex-col">
                            <span className="text-lg font-bold text-green-600 text-left">
                                -99,000
                            </span>
                            <span className="text-xs text-gray-500 text-left">
                                09:45
                            </span>
                        </div>
                    </div>
                </div>
            </div> */}
      {/* yesterday */}
      {/* <div>
                <h3 className="text-sm font-semibold text-gray-500 mb-3 px-2">
                    Yesterday
                </h3>
                <div className="bg-white rounded-2xl border border-gray-100 divide-y divide-gray-50">
                    <div className="p-4 flex items-center justify-between">
                        <div className="flex items-center">
                            <div className="w-12 h-12 bg-green-50 rounded-2xl flex items-center justify-center">
                                <FaPercent className="text-green-600" />
                            </div>

                            <div className="text-right mr-3">
                                <h4 className="font-semibold text-gray-900">
                                    Commission Withdrawal
                                </h4>
                                <p className="text-sm text-gray-500">
                                    Bank Transfer
                                </p>
                            </div>
                            <div className="text-right mr-3"></div>
                        </div>
                        <div className="flex flex-col">
                            <span className="text-lg font-bold text-green-600 text-left">
                                -300,000
                            </span>
                            <span className="text-xs text-gray-500 text-left">
                                18:20
                            </span>
                        </div>
                    </div>
                </div>
                <div className="bg-white rounded-2xl border border-gray-100 divide-y divide-gray-50">
                    <div className="p-4 flex items-center justify-between">
                        <div className="flex items-center">
                            <div className="w-12 h-12 bg-blue-50 rounded-2xl flex items-center justify-center">
                                <FaChartLine className="text-blue-600" />
                            </div>
                            <div className="text-right mr-3">
                                <h4 className="font-semibold text-gray-900">
                                    Signal Fee
                                </h4>
                                <p className="text-sm text-gray-500">
                                    Package
                                    mike_trader
                                </p>
                            </div>
                            <div className="text-right mr-3"></div>
                        </div>
                        <div className="flex flex-col">
                            <span className="text-lg font-bold text-green-600 text-left">
                                +50,000
                            </span>
                            <span className="text-xs text-gray-500 text-left">
                                11:15
                            </span>
                        </div>
                    </div>
                </div>
                <div className="bg-white rounded-2xl border border-gray-100 divide-y divide-gray-50">
                    <div className="p-4 flex items-center justify-between">
                        <div className="flex items-center">
                            <div className="w-12 h-12 bg-red-50 rounded-2xl flex items-center justify-center">
                                <FaWallet className="text-red-600" />
                            </div>
                            <div className="text-right mr-3">
                                <h4 className="font-semibold text-gray-900">
                                    Wallet Top-up
                                </h4>
                                <p className="text-sm text-gray-500">
                                    Credit Card
                                </p>
                            </div>
                            <div className="text-right mr-3"></div>
                        </div>
                        <div className="flex flex-col">
                            <span className="text-lg font-bold text-green-600 text-left">
                                +500,000
                            </span>
                            <span className="text-xs text-gray-500 text-left">
                                13:30
                            </span>
                        </div>
                    </div>
                </div>
            </div> */}
      {/* this week */}
      {/* <div>
                <h3 className="text-sm font-semibold text-gray-500 mb-3 px-2">
                    This Week
                </h3>
                <div className="bg-white rounded-2xl border border-gray-100 divide-y divide-gray-50">
                    <div className="p-4 flex items-center justify-between">
                        <div className="flex items-center">
                            <div className="w-12 h-12 bg-indigo-50 rounded-2xl flex items-center justify-center">
                                <FaStar className="text-indigo-600" />
                            </div>
                            <div className="text-right mr-3">
                                <h4 className="font-semibold text-gray-900">
                                    Signal Package
                                    Purchase
                                </h4>
                                <p className="text-sm text-gray-500">
                                    Package
                                    john_smith
                                </p>
                            </div>
                            <div className="text-right mr-3"></div>
                        </div>
                        <div className="flex flex-col">
                            <span className="text-lg font-bold text-green-600 text-left">
                                +150,000
                            </span>
                            <span className="text-xs text-gray-500 text-left">
                                14:30
                            </span>
                        </div>
                    </div>
                </div>
                <div className="bg-white rounded-2xl border border-gray-100 divide-y divide-gray-50">
                    <div className="p-4 flex items-center justify-between">
                        <div className="flex items-center">
                            <div className="w-12 h-12 bg-green-50 rounded-2xl flex items-center justify-center">
                                <FaUsers className="text-green-600" />
                            </div>
                            <div className="text-right mr-3">
                                <h4 className="font-semibold text-gray-900">
                                    Invite Reward
                                </h4>
                                <p className="text-sm text-gray-500">
                                    Mary Johnson
                                    joined
                                </p>
                            </div>
                            <div className="text-right mr-3"></div>
                        </div>
                        <div className="flex flex-col">
                            <span className="text-lg font-bold text-green-600 text-left">
                                +50,000
                            </span>
                            <span className="text-xs text-gray-500 text-left">
                                11:15
                            </span>
                        </div>
                    </div>
                </div>
                <div className="bg-white rounded-2xl border border-gray-100 divide-y divide-gray-50">
                    <div className="p-4 flex items-center justify-between">
                        <div className="flex items-center">
                            <div className="w-12 h-12 bg-yellow-50 rounded-2xl flex items-center justify-center">
                                <FaBell className="text-yellow-600" />
                            </div>
                            <div className="text-right mr-3">
                                <h4 className="font-semibold text-gray-900">
                                    Subscription Renewal
                                </h4>
                                <p className="text-sm text-gray-500">
                                    Premium Plan
                                </p>
                            </div>
                            <div className="text-right mr-3"></div>
                        </div>
                        <div className="flex flex-col">
                            <span className="text-lg font-bold text-green-600 text-left">
                                -99,000
                            </span>
                            <span className="text-xs text-gray-500 text-left">
                                09:45
                            </span>
                        </div>
                    </div>
                </div>
            </div> */}
    </div>
  );
}
